import {Platform, StyleSheet, useWindowDimensions} from 'react-native';
import {ITheme} from 'contexts/ThemeContext';

export default ({colors, typography}: ITheme) => {
  const {width} = useWindowDimensions();

  return StyleSheet.create({
    containerStyle: {
      justifyContent: 'center',
      alignItems: 'center',
      width: width - 32,
      padding: 16,
      backgroundColor: colors.white,
      borderRadius: 12,
    },
    defaultBackDropStyle: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.transparentPrimary,
    },
  });
};
